import React from 'react';
import StyleFormPreview from './components/StyleFormPreview';

const CreateStyle = () => {
  return <StyleFormPreview />;
};

export default CreateStyle;
